import { useEffect, useState } from 'react';
import { LiveText, motion } from '../Motion';
import { nextVerbIndex, WAITING_VERBS } from './waiting-verbs';

/** How long each verb stays up. Long enough to read a three-word phrase. */
const VERB_MS = 2_200;

/** The header's words before the first byte of a reply arrives: a rotating
 *  bit of insurance shop talk, shimmering, crossfading on each change. */
export function WaitingVerb() {
  const [index, setIndex] = useState(() =>
    Math.floor(Math.random() * WAITING_VERBS.length)
  );

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => nextVerbIndex(prev, WAITING_VERBS.length));
    }, VERB_MS);
    return () => clearInterval(timer);
  }, []);

  return (
    <span key={index} className={motion.tickIn}>
      <LiveText>{`${WAITING_VERBS[index]}…`}</LiveText>
    </span>
  );
}
